import React, { useEffect, useState } from 'react';
import axios from "axios";
import ReactDOMServer from 'react-dom/server';
import { AppDatePicker, AppRemixIcon, AppSingleSelect } from '@/layout/AppComponents';
import BtnOptions from './BtnOptions';
import Translator from '../../../../components/helpers/Translator';
import { axiosPath } from '../../../../../routing/helpers/router';
import useIsMounted from '../../../../components/hooks/useIsMounted';

const Report25Options = (props) => {
  const { handleOnSetFieldValue, handleOnSubmit, handleOnSave, values } = props;
  const isMounted = useIsMounted();
  const [reportOptions, setReportOptions] = useState();

  // > LOAD REPORT OPTIONS //
  useEffect(() => {
    axios
      .post(axiosPath("api_r_user_module_intelligence_getReportOptions"), {
        report: 25,
      })
      .then((r) => {
        if (isMounted.current) {
          setReportOptions(r.data);
        }
      })
      .catch(() => "");
  }, []);
  // < LOAD REPORT OPTIONS //

  if (!reportOptions) return <></>;

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <AppSingleSelect
            icon={<AppRemixIcon icon="apps-2" />}
            options={reportOptions?.saicaPlantGroups || []}
            title={
              <Translator file="module-intelligence" name="module.int.group" />
            }
            placeholder={ReactDOMServer.renderToString(
              <Translator file="module-intelligence" name="select.an.option" />
            )}
            value={values.saicaPlantGroup}
            onChange={(e) => handleOnSetFieldValue('saicaPlantGroup', e)}
            hasSearchBox
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <AppDatePicker
            title={<Translator file="module-intelligence" name="date" />}
            value={values.date}
            onChange={(opt) => handleOnSetFieldValue('date', opt)}
            placeholder="dd/mm/yyyy"
            showMonthDropdown
            showYearDropdown
            isClearable
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <BtnOptions
                isDisabled={!values.saicaPlantGroup || !values.date}
                handleOnSave={() => handleOnSave(true)}
                handleOnSubmit={() => handleOnSubmit()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report25Options;
